<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">APP使用紀錄</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="dataList"
        :headers="headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td 
              v-for="header in headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value === 'events'" style="display: block; white-space:pre-wrap;">
                {{item[header.value]}}
              </div>
              <div v-else-if="header.value === 'account_nm'">
                {{ item.account_nm === null ? item.user_id : item.account_nm }}
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebarWidth"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5"
            v-if='sidebarOpen'
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-arrow-expand-left
          </v-icon>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            class="mr-5 mt-5"
            v-else
            @click="sidebarOpen=!sidebarOpen"
          >
            mdi-tune-variant
          </v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebarOpen">
          <v-card-title style="height:50px;" class="searchTitle">作業時間(起)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchStartDateMenu"
              v-model="searchStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchStartDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchStartDate"
                @input="searchStartDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">作業時間(迄)(不包含)</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-menu
              ref="searchEndDateMenu"
              v-model="searchEndDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="searchEndDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                  dense
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchEndDate"
                @input="searchEndDateMenu = false"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">作業名稱</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-autocomplete
              v-model="searchApiInfo"
              :items="api_info"
              item-text="text"
              item-value="value"
              required
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            >
            </v-autocomplete>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">主機編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-autocomplete
              v-model="searchSiteMno"
              :items="site_mno"
              item-text="text"
              item-value="value"
              required
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            >
            </v-autocomplete>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">作業資訊</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="searchEvents"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">標的物名稱列表</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-autocomplete
              v-model="searchSiteId"
              :items="site_id"
              item-text="text"
              item-value="value"
              required
              class="rounded-lg"
              dense
              outlined
              hide-details
              clearable
            >
            </v-autocomplete>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
export default {
  name: 'Log_Info_View.',
  data: () => ({
    isLoading: false,
    headers: [
      { text: '作業人員', value: 'account_nm', width: '110', sortable: true },
      { text: '作業名稱', value: 'apiname', width: '150', sortable: true },
      { text: '作業資訊', value: 'events', width: '300', sortable: true },
      { text: '作業資訊(多語系測試)', value: 'eventsLang', width: '300', sortable: true },
      { text: '作業時間', value: 'dt', width: '150', sortable: true },
      { text: '地點列表', value: 'site_nm', width: '150', sortable: true },
      { text: '主機編號', value: 'site_mno', width: '150', sortable: true },
    ],
    searchStartDate: '',
    searchStartDateMenu: false,
    searchEndDate: '',
    searchEndDateMenu: false,
    searchApiInfo: '',
    searchSiteMno: '',
    searchEvents: '',
    searchSiteId: '',
    rows: 10,
    sortItem: 'account_nm',
    sortOrder: false,
    total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    dataList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    sendTime: '00',
    api_info: [
      {value:'CreatePermission',text:'新增使用者權限'},
      {value:'ModifyPermission',text:'修改使用者權限'},
      {value:'DeletePermission',text:'刪除使用者權限'},

      {value:'ModifyDeviceAlarmArea',text:'偵測/遮蔽區塊設定'},

      {value:'SetDeviceBinding',text:'設定設備綁定'}, 
      {value:'RemoveDeviceBinding',text:'解除設備綁定'},

      {value:'SetSiteProtected',text:'設定標的物保全設解'}, 
      {value:'SetAreaProtectActivated',text:'設定區域保全設解'}, 
      
      {value:'CreateSchedule', text:'新增排程設定'},
      {value:'ModifySchedule', text:'更新排程設定'},
      {value:'DeleteSchedule', text:'刪除排程設定'},
      {value:'SetScheduleActivated', text:'設定排程設定開關'},
      {value:'SetSiteSchedule',text:'設定排程設解開關'}, 
      {value:'SetDeviceScheduleParam',text:'設定排程設解設備參數'}, 
      {value:'ScheduledDispatch', text:'排程設解'},
      
      {value:'SetHubBinding', text:'設定 Hub 綁定'},
      {value:'', text:''},
  ],
    site_mno: [],
    site_id: [],
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.setDefultDate()
    this.getDictionary()
  },
  watch: {
    page () {
      this.getPageData()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchStartDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchEndDate () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchApiInfo () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteMno () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchEvents () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    },
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    changeSortItem () {
      this.sortItem = 'billing_number'
    },
    getDictionary () {
      var parm = ['site_mno(withRemoved)', 'site_id(withRemoved)']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var site_mnoIndex = response.data.map(function (item) { return item.dicNo }).indexOf('site_mno(withRemoved)')
            var site_idIndex = response.data.map(function (item) { return item.dicNo }).indexOf('site_id(withRemoved)')
            var site_mno = response.data[site_mnoIndex].data
            var site_id = response.data[site_idIndex].data
            site_mno.forEach(element => {
              var site_mno = {
                value: element.key,
                text: element.key + ' ' + element.value
              }
              this.site_mno.push(site_mno)
            })
            site_id.forEach(element => {
              var site_id = {
                value: element.key,
                text: element.key + ' ' + element.value
              }
              this.site_id.push(site_id)
            })
            this.getPageData()
          }
        })
    },
    setDefultDate () {
      var d = new Date()
      var endDate = d.getFullYear()
      if ((d.getMonth() + 1) < 10) {
        endDate = endDate + '-0' + (d.getMonth() + 1)
      } else {
        endDate = endDate + '-' + (d.getMonth() + 1)
      }
      if ((d.getDate()) < 10) {
        endDate = endDate + '-0' + (d.getDate())
      } else {
        endDate = endDate + '-' + (d.getDate())
      }
      this.searchStartDate = this.searchEndDate = endDate
    },
    getPageData () {
      this.isLoading = true
      this.pageCount = 0
      this.dataList = []
      var searchStartDate = {
        name: 'dt',
        value: this.searchStartDate,
        displayType: 'thanorequal'
      }
      var searchEndDate = {
        name: 'dt',
        value: this.searchEndDate,
        displayType: 'lessorequal'
      }
      var searchApiInfo = {
        name: 'apiname',
        value: this.searchApiInfo,
        displayType: '='
      }
      var searchSiteMno = {
        name: 'site_mno',
        value: this.searchSiteMno,
        displayType: '='
      }
      var searchEvents = {
        name: 'events',
        value: this.searchEvents,
        displayType: 'like'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: '='
      }
      var wheres = [searchStartDate, searchEndDate, searchApiInfo, searchSiteMno, searchEvents, searchSiteId]
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'log_info_view/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.total = response.data.total
            this.pageCount = Math.ceil(this.total / this.rows)
            this.dataList = response.data.rows
            this.dataList.forEach(element => {
              element.eventsLang = this.$t(element.apiname + "_" + element.ResultCode)

              element.eventsLang = element.eventsLang
                .replace("{param1}", element.param1)
                .replace("{param2}", element.param2)
                .replace("{param3}", element.param3)
                .replace("{param4}", element.param4)
                .replace("{param5}", element.param5)
              
              var api_info = this.api_info.find(x => x.value === element.apiname)
              if(api_info){
                element.apiname = api_info.text
              }
            })
          }
        })
      .finally(() => {
        this.isLoading = false
      })
    },
  }
}
</script>
